module.exports = __webpack_public_path__ + "img/bg.fc09e8c3.png";